import { common, IOHelper, JSONHelper, toJSONStorageFlags, } from '@neo-one/client-common';
import { createSerializeWire, } from './Serializable';
import { BinaryReader, utils } from './utils';
export class StorageItem {
    constructor({ hash, key, value, flags }) {
        this.equals = utils.equals(StorageItem, this, (other) => common.uInt160Equal(this.hash, other.hash) &&
            this.key.equals(other.key) &&
            this.value.equals(other.value) &&
            this.flags === other.flags);
        this.serializeWire = createSerializeWire(this.serializeWireBase.bind(this));
        this.hash = hash;
        this.key = key;
        this.value = value;
        this.flags = flags;
        this.sizeInternal = utils.lazy(() => IOHelper.sizeOfUInt160 +
            IOHelper.sizeOfVarBytesLE(this.key) +
            IOHelper.sizeOfVarBytesLE(this.value) +
            IOHelper.sizeOfUInt8);
    }
    static deserializeWireBase({ reader }) {
        const hash = reader.readUInt160();
        const key = reader.readVarBytesLE();
        const value = reader.readVarBytesLE();
        const flags = reader.readUInt8();
        return new this({
            hash,
            key,
            value,
            flags,
        });
    }
    static deserializeWire(options) {
        return this.deserializeWireBase({
            context: options.context,
            reader: new BinaryReader(options.buffer),
        });
    }
    get size() {
        return this.sizeInternal();
    }
    update({ value, flags }) {
        return new StorageItem({
            hash: this.hash,
            key: this.key,
            value,
            flags,
        });
    }
    serializeWireBase(writer) {
        writer.writeUInt160(this.hash);
        writer.writeVarBytesLE(this.key);
        writer.writeVarBytesLE(this.value);
        writer.writeUInt8(this.flags);
    }
    serializeJSON(_context) {
        return {
            hash: JSONHelper.writeUInt160(this.hash),
            key: JSONHelper.writeBuffer(this.key),
            value: JSONHelper.writeBuffer(this.value),
            flags: toJSONStorageFlags(this.flags),
        };
    }
}

//# sourceMappingURL=StorageItem.js.map
